import * as React from 'react';

import {KeyTriggeredAnimateIn} from 'shells/animation/key-triggered-animate-in';
import {Stack} from 'shells/layout/stack/stack';

import type {AiFeatureType} from 'nutshell-graphql-types';

import {NoUsageSection} from './no-usage-section';
import {UsageHeader} from './usage-header';
import type {TabProps} from './usage-header';
import {UsageStatsSection} from './usage-stats-section';
import type {UsageStatsSectionProps} from './usage-stats-section';

interface Props {
    hasAiUsage: boolean | null | undefined;
    isLoadingHasAiUsage: boolean;
    statsSectionProps: UsageStatsSectionProps;
    tabProps: TabProps;
    featureType?: AiFeatureType;
}

export function UsageSection(props: Props) {
    let content = (
        <UsageStatsSection
            // @ts-expect-error
            isLoadingData={props.isLoadingHasAiUsage || props.statsSectionProps.isLoadingData}
            {...props.statsSectionProps}
        />
    );

    if (!props.hasAiUsage && !props.isLoadingHasAiUsage) {
        content = <NoUsageSection />;
    }

    return (
        // @ts-expect-error
        <KeyTriggeredAnimateIn triggerKey={props.featureType ?? ''}>
            <Stack isFullWidth={true} spacing={16}>
                <UsageHeader tabProps={props.hasAiUsage ? props.tabProps : undefined} />
                {content}
            </Stack>
        </KeyTriggeredAnimateIn>
    );
}
